import { FiCreditCard } from "react-icons/fi";
import useBusinessMerchant from "../../../Routes/Marketplace/Merchant/lib/fetchBusinessMerchant";
import PageHeader from "../../components/PageHeader";
import MerchantPayoutDestination from "../components/MerchantPayoutDestination";
import MerchantPaymentPanel from "../components/MerchantPaymentPanel";

const MerchantPaymentsPage = () => {
  const { data: businessData, isLoading } = useBusinessMerchant();
  const merchant = businessData?.merchant;

  return (
    <>
      <PageHeader
        title="Payments"
        subtitle="Set up payouts, track earnings by order, and request withdrawals"
        icon={FiCreditCard}
      />

      <MerchantPayoutDestination merchant={merchant} isLoading={isLoading} />

      <div className="dashboard-card">
        <h2 className="dashboard-card__title">Earnings & payouts</h2>
        <MerchantPaymentPanel merchant={merchant} />
      </div>
    </>
  );
};

export default MerchantPaymentsPage;
